<script>
import { mapGetters } from 'vuex';
import { hasPressedCommand } from 'shared/helpers/KeyboardHelpers';
import GalleryView from '../components/GalleryView.vue';
import { timeStampAppendedURL } from 'dashboard/helper/URLHelper';
import { emitter } from 'shared/helpers/mitt';
import MyButton from 'dashboard/components-next/button/Button.vue';
import { useAlert, useTrack } from 'dashboard/composables';
import {
  getUserPermissions,
  hasPermissions,
} from 'dashboard/helper/permissionsHelper.js';

export default {
  components: {
    MyButton,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      isImageError: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      currentAccountId: 'getCurrentAccountId',
    }),
    isDisabledCreate() {
      //return this.message.content_attributes?.bank_account;
      return false;
    },
    userPermissions() {
      return getUserPermissions(this.currentUser, this.currentAccountId);
    },
    messageContent() {
      return this.message.content;
    },
  },
  methods: {
    onInitOrder() {
      emitter.emit('showGiftCardWithdraw', this.message);
    },
  },
};
</script>

<template>
  <div class="flex-row">
    <p class="text-blue-600">{{ messageContent }}</p>
    <div class="flex flex-row mt-4">
      <MyButton sm :disabled="isDisabledCreate" @click="onInitOrder">
        Do Payment
      </MyButton>
    </div>
  </div>
</template>
